import React from 'react'
import './Explore.css'
import UpcomingEvents from '../Events/UpcomingEvents'
import AboutIITD from '../About/AboutIITD'
import Alumni from '../Alumni/Alumni'
import AboutOutreach from '../About/AboutOutreach'
import Messages from '../Messages/Messages'

// import all_events from '../../data/Events/upcoming_events'
import Calender from '../Calender/Calender'
// import MiniGallery from '../Gallery/MiniGallery'
import UpdatedGallery from '../updated-gallery/gallery-updated'
import Announcements from '../Announcements/Announcements'

export default function Explore() {
    return (
        <section>
            <UpcomingEvents title="Upcoming Events" />
            <Announcements />
            {/* <AboutIITD /> */}
            <AboutOutreach />
            <Messages />
            <Alumni />
            <UpdatedGallery />
            {/* <Calender/> */}
        </section>
    )
}
